module.exports = __webpack_public_path__ + "static/Local_Business-5a0d37a87ac02dd3616d26d27fb10c74.jpg";